import {
  DOMAIN_LIST,
  DOMAIN_LIST_SUCCESS,
  ADD_CUSTOM_DOMAIN_SUCCESS,
  DOMAIN_DELETE_SUCCESS,
} from './type'
// eslint-disable-next-line import/no-anonymous-default-export
export default function (
  state = {
    list: { results: null, totalCount: 0 },
    query: null,
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case DOMAIN_LIST:
      return { ...state, query: payload.query }
    case DOMAIN_LIST_SUCCESS:
      return { ...state, list: payload.response }
    case ADD_CUSTOM_DOMAIN_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          results: [payload.response.data, ...state.list.results],
          totalCount: state.list.totalCount + 1,
        },
      }
    case DOMAIN_DELETE_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          results: state.list.results.filter(
            item => item.id !== payload.response,
          ),
          totalCount: state.list.totalCount - 1,
        },
      }
    default:
      return state
  }
}
